<template>
  <fragment>
    <div class="row" v-if="entity">
      <div class="col-12">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="tab-content" id="v-pills-product-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-general"
                role="tabpanel"
                aria-labelledby="v-pills-general-tab"
              >
                <!-- generale -->
                <div id="baseinformation" v-if="entity">
                  <div class="row">
                    <taglist
                      v-model="entity.tags"
                      :readOnlyReserved="false"
                      :exclude="['allegati']"
                    ></taglist>
                  </div>

                  <div class="row">
                          <div class="col-12">
                      <div class="form-group">
                        <ValidationProvider
                          v-slot="{ classes, errors }"
                          immediate
                          slim
                          rules="required"
                        >
                          <label class="col-form-label" for="lastName"
                            >Username (Mail)</label
                          >
                          <input
                            type="text"
                            class="form-control required"
                            :readonly="inputReadOnly"
                            id="username"
                            name="username"
                            placeholder="username"
                            v-model="entity.username"
                            :class="classes"
                            @change="checkUsername"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <ValidationProvider
                          v-slot="{ classes, errors }"
                          immediate
                          slim
                          rules="required"
                        >
                          <label class="col-form-label" for="firstName"
                            >Nome</label
                          >
                          <input
                            type="text"
                            class="form-control required"
                            :readonly="inputReadOnly"
                            id="firstName"
                            name="firstName"
                            placeholder="Nome"
                            v-model="entity.firstName"
                            :class="classes"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <!--<form @submit.prevent="save" v-if="entity">-->
                    <div class="col-12">
                      <div class="form-group">
                        <ValidationProvider
                          v-slot="{ classes, errors }"
                          immediate
                          slim
                          rules="required"
                        >
                          <label class="col-form-label" for="lastName"
                            >Cognome</label
                          >
                          <input
                            type="text"
                            class="form-control required"
                            :readonly="inputReadOnly"
                            id="lastName"
                            name="lastName"
                            placeholder="Cognome"
                            v-model="entity.lastName"
                            :class="classes"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                     <div class="col-12 mt-3">
<h4 class="page-title">Abilitazione utente</h4>
</div>
                    <div class="col-12">
                      <div
                        class="custom-control custom-checkbox custom-control-inline"
                      >
                        <input
                          v-model="entity.enabled"
                          type="checkbox"
                          id="enabled"
                          name="enabled"
                          class="custom-control-input"
                        />
                        <label class="custom-control-label" for="enabled"
                          >Utente abilitato</label
                        >
                      </div>
                    </div>
                     <div class="col-12 mt-3">
<h4 class="page-title">Profili utente</h4>
</div>
                     <div class="col-12" v-for="profile in profiles">
                      <div
                        class="custom-control custom-checkbox custom-control-inline"
                       >
                        <input
                         
                          :value="profile.userRoleId"
                          type="checkbox"
                          :id="profile.userRoleId"
                         
                          class="custom-control-input"
                           v-model="selectedProfiles"
                        />
                        <label class="custom-control-label" :for="profile.userRoleId"
                          >{{profile.name}}</label
                        >
                      </div>
                   
                    </div>
              
                  </div>

                  <div class="row">
                    <div class="form-group mt-3">
                      <button
                        type="button"
                        class="btn btn-xs btn-primary-rgba mr-2"
                        v-on:click="save"
                        v-if="$store.getters.isInRole('user-edit')"
                      >
                        Salva
                        <font-awesome-icon
                          :icon="['far', 'save']"
                        ></font-awesome-icon>
                      </button>
                      <button
                        type="button"
                        class="btn btn-xs btn-danger-rgba mr-2"
                        v-on:click="cancel"
                      >
                        Annulla
                        <font-awesome-icon
                          :icon="['far', 'times-circle']"
                        ></font-awesome-icon>
                      </button>
                       <button
                        type="button"
                        class="btn btn-xs btn-danger ml-5"
                        v-on:click="resetPassword"
                        v-if="$store.getters.isInRole('user-resetpassword')"
                      >
                        Resetta password utente
                        <font-awesome-icon
                          :icon="['fas', 'recycle']"
                        ></font-awesome-icon>
                      </button>
                    </div>
                    <!--</form>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </fragment>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import { Chrome } from "vue-color";
import { Slider } from "vue-color";
export default {
  data() {
    return {
      entity: null,
      profiles:[],
      selectedProfiles:[]
    };
  },
  computed: {
    tagTypes: function () {
      return this.$store.state.tagTypes;
    },
    tinyKey: function () {
      return window.SETTINGS.TinyApiKey;
    },
    inputReadOnly: function () {
      if (this.entity) return this.entity.isImported;
      return true;
    },
  },
  components: {
    Editor,
    "chrome-picker": Chrome,
  },
  name: "UserSave",
  beforeMount() {
    var me = this;
  axios
      .get(
        "user/profiles"
      )
      .then((response) => {
        me.profiles = response.data;
       
      });
    axios
      .get(
        "user/" + me.$route.params.id || "00000000-0000-0000-0000-000000000000"
      )
      .then((response) => {
        me.entity = response.data;
        me.selectedProfiles = me.entity.roles.split(';');
        if (me.entity.firstName != "")
          me.$store.state.breadCrump.title = me.entity.firstName+' '+me.entity.lastName;
      });
  },
  methods: {
    cancel() {
      this.$router.push({
        name: "route-user-list",

        replace: true,
      });
    },
    checkUsername() {
      var me = this;
      axios.post(`user/emailexists`, this.entity).then((response) => {
        if (response.data == "KO") {
          me.$swal({
            title: `Esiste già un utente con lo username "<strong>${this.entity.username.toString()}</strong>"`,
            text: "",
            type: "error",
            showCancelButton: false,
            toast: true,
            timer: 2000,
            showConfirmButton: false,
            position: "bottom-top",
          });
          this.entity.username = "";
        }
      });
    },
    updateFromPicker(color) {
      this.entity.backgroundColor = color.hex;
    },
    resetPassword(){
 let me = this;
 me.$swal({
        title: ``,
        html: `Sicuri di resettare la password all'utente?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .post('user/resetpassword/'+me.entity.userId)
            .then((response) => {
              me.$swal({
                title: "Reset password avvenuto con successo",
                text: "",
                type: "success",
                showCancelButton: false,
                toast: true,
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-top",
              });

             me.$router.go();
            });
        }
      });
    },
    save() {
      let me = this;

       axios.post(`user/emailexists`, this.entity).then((response) => {
        if (response.data == "KO") {
          me.$swal({
            title: `Esiste già un utente con lo username "<strong>${this.entity.username.toString()}</strong>"`,
            text: "",
            type: "error",
            showCancelButton: false,
            toast: true,
            timer: 2000,
            showConfirmButton: false,
            position: "bottom-top",
          });
        }
        else{

          me.entity.roles = me.selectedProfiles.join(';');
      axios.post("user/save", this.entity).then((response) => {
        

        me.$swal({
          title: "Salvataggio avvenuto correttamente",
          text: "",
          type: "success",
          showCancelButton: false,
          toast: true,
          timer: 2000,
          showConfirmButton: false,
          position: "bottom-top",
        });

        if (me.$route.params.id != response.data.data.userId) {
          me.$router.push({
            name: "route-user-edit",
            params: { id: response.data.data.userId },
          });
        }
      });

        }
      });


    },
  },
};
</script>
